<div #container class="nc-soft-aurora-canvas-container"></div>
<div class="nc-content-wrapper">
    <ng-content></ng-content>
</div>
